import { z } from "zod";

import { fetchWithError, useParsedQuery } from "@nens/react-query-utils";

import { AUTH_API_BASE_URL } from "../constants";

const tenantsListItemSchema = z.object({
  id: z.number(),
  name: z.string(),
});

const tenantsListSchema = z.array(tenantsListItemSchema);

export type Tenant = z.infer<typeof tenantsListItemSchema>;

export function useTenants() {
  const url = `${AUTH_API_BASE_URL}/tenants/`;
  return useParsedQuery<Tenant[]>(
    ["ldo-auth-v1", "tenants"],
    () => fetchWithError(url),
    (json: unknown) => tenantsListSchema.parse(json)
  );
}
